// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__rk-h+","content":"style_content__D18lI","icons":"style_icons__OjBeS"};